import { Family } from 'common/api/crm/models/Family';
import { CartLineItem } from 'common/api/e-comm/models/CartLineItem';
import { CategoryData } from 'common/api/categories/models/CategoryData';

type RoktCartItem = {
    majorCat: string;
    majorCatID: string | number;
    minorCat1: string;
    minorCat1ID: string;
    sku: string;
    productName: string;
    quantity: number;
    price: number;
    numberOfProducts: number;
};

export type AttributesType = {
    email: string;
    firstname: string;
    confirmationref: string;
    amount: number;
    country: string;
    language: string;
    currency: string;
    cartItems: RoktCartItem[];
};

function mapCartItemsToRoktCartItems(
    cartItems: CartLineItem[],
    categories: Pick<CategoryData, 'id' | 'name' | 'iconUrl'>[],
    dedupeList: { [key: number]: string[] } | string
): RoktCartItem[] {
    return cartItems.map((cartItem) => {
        const majorCat =
            (dedupeList[cartItem.product.brandId] as string) ||
            (categories || []).find((c) => c.id === cartItem.product.categories[0])?.name ||
            '';
        const majorCatID =
            categories.find((category) => category.name === majorCat[0])?.id ??
            '' + cartItem.product.categories[0];

        return {
            // if the brandId on the cart item is in the dedupe list, then use that
            // otherwise use the first category id to lookup in categories
            majorCat: majorCat,
            majorCatID,
            minorCat1: cartItem.product.type,
            minorCat1ID: cartItem.product.type,
            sku: cartItem.product.sku,
            productName: cartItem.product.name,
            quantity: 1,
            numberOfProducts: cartItem.quantity,
            price: cartItem.price,
        };
    });
}

export const getRoktAttributes = ({
    amount,
    profile,
    cartItems,
    allCategories,
    dedupeList,
}: {
    amount: number;
    profile: Family;
    cartItems: CartLineItem[];
    allCategories: Pick<CategoryData, 'id' | 'name' | 'iconUrl'>[];
    dedupeList: { [key: number]: string[] } | string;
}): AttributesType => {
    const roktCartItems = mapCartItemsToRoktCartItems(cartItems, allCategories, dedupeList);
    return {
        email: profile?.email || '',
        firstname: profile?.firstName || '',
        confirmationref: '',
        amount: amount,
        currency: 'USD',
        country: 'US',
        language: 'EN',
        cartItems: roktCartItems,
    };
};
